var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcIrrBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_1272)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 33.6956V18.0377C1.24651 17.0264 1.54372 15.6948 3.32981 16.0035C2.99077 18.1387 4.65711 19.4415 6.92796 18.8442C9.75858 18.0969 9.49168 15.5909 11.8722 16.0021C11.6385 17.4823 14.5369 18.5196 15.7646 18.8442L12.8301 33.6956H0ZM4.14062 27.7415C4.14062 27.5525 4.06553 27.3712 3.93187 27.2375C3.79821 27.1039 3.61693 27.0288 3.42791 27.0288C3.23889 27.0288 3.05761 27.1039 2.92395 27.2375C2.79029 27.3712 2.71521 27.5525 2.71521 27.7415C2.71521 27.9305 2.79029 28.1118 2.92395 28.2455C3.05761 28.3791 3.23889 28.4542 3.42791 28.4542C3.61693 28.4542 3.79821 28.3791 3.93187 28.2455C4.06553 28.1118 4.14062 27.9305 4.14062 27.7415ZM8.01866 24.0626C8.01885 23.9432 7.99553 23.825 7.95002 23.7146C7.90452 23.6043 7.83773 23.504 7.75346 23.4194C7.6692 23.3349 7.5691 23.2678 7.4589 23.2219C7.3487 23.1761 7.23055 23.1524 7.11119 23.1522C6.99182 23.152 6.8736 23.1753 6.76325 23.2208C6.6529 23.2663 6.5526 23.3331 6.46806 23.4174C6.38353 23.5017 6.31642 23.6018 6.27057 23.712C6.22471 23.8222 6.20102 23.9403 6.20083 24.0597C6.20044 24.3007 6.29584 24.5321 6.46602 24.7028C6.63621 24.8735 6.86724 24.9696 7.1083 24.97C7.34936 24.9704 7.5807 24.875 7.75142 24.7048C7.92215 24.5347 8.01828 24.3036 8.01866 24.0626ZM35.3309 32.4073H45V33.6956H35.5646L35.3309 32.4073ZM34.6066 33.6956L29.661 13.0358C29.521 12.4328 29.0233 11.9999 28.4433 11.9999H19.5864C19.005 11.9999 18.5087 12.4328 18.3702 13.0329L14.0608 33.6956H34.6066Z",
    fill: "#7BACC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_1272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIrrBorder);
export default __webpack_public_path__ + "static/media/ic-irr-border.b0dc2675225d39177689fd4a3206f44d.svg";
export { ForwardRef as ReactComponent };